import { schema } from 'normalizr';
import { cardTypes } from '../../settings/constants';

export const assignmentSchema = new schema.Entity(
  'assignments',
  {},
  {
    idAttribute: 'assignGuid',
    processStrategy: value => ({
      ...value,
      hasAssignedCopies: value.assignedCopiesCount > 0,
      isMasterOrReview: value.cardType === cardTypes.MASTER || value.cardType === cardTypes.REVIEW,
    }),
  },
);

const availabilitySchema = new schema.Entity(
  'availabilities',
  {
    assignments: [assignmentSchema],
  },
  {
    processStrategy: (value, parent) => ({
      ...value,
      isFirst: parent.availabilities[0].id === value.id,
      postingId: parent.id,
    }),
  },
);

const clinicianSchema = new schema.Entity(
  'clinicians',
  {},
  {
    processStrategy: (value, { availabilities }) => ({ ...value, availabilities }),
  },
);

export const postingSchema = new schema.Entity('postings', {
  availabilities: [availabilitySchema],
  clinician: clinicianSchema,
});
